import {Container, Grid, Typography, useMediaQuery} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import billPay_img from "assets/images/home_content_3.png";
import EasyImg from "assets/images/Easy.png";
import FASTImg from "assets/images/FAST.png";
import FreeImg from "assets/images/Free.png";
import SafeImg from "assets/images/Safe.png";
import IconHeader from "components/public-dashboard/components/iconHeader";
import TextList from "components/public-dashboard/components/TextList";

const useStyles = makeStyles((theme) => ({
  img: {
    width: "60%",
  },
    iconImg: {
      height: "150px"
    },
    iconContainer: {
      padding: "0 28px 60px  28px"
    },
    iconContainerParagraph: {
      height: "250px",
      textAlign: "left",
      [theme.breakpoints.down("sm")]: {
          height: "50px",
     },
    }
}));

export default function TopupHeader() {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const xs = useMediaQuery(theme.breakpoints.down("xs"));



    const mdIconCol = useMediaQuery(theme.breakpoints.down("md"));
    const smIconCol = useMediaQuery(theme.breakpoints.down("sm"));
    const xsIconCol = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Container>
      <Grid container direction="row" justify="center" alignItems="center">
        {xs && (
          <Grid item xs={6}>
            <IconHeader
              title="Pay Bills"
              iconColor="#C60B17"
              titleColor="#008bee"
              titleLg="h2"
              titleXs="h4"
            />
          </Grid>
        )}
        {xs && (
          <Grid item xs={6}>
            <img src={billPay_img} alt="billpay" className={classes.img} />
          </Grid>
        )}
          <Grid item container xs={12} sm={7}>
              {sm && (
                  <Grid item>
                      <IconHeader
                          title="Pay Bills"
                          iconColor="#C60B17"
                          titleColor="#008bee"
                          titleLg="h2"
                      />
                  </Grid>
              )}

              <Grid item container>
                  <TextList
                      items={[
                          <span>
                  Fed up of the long lines, the paperwork and the hassle?
                </span>,
                          <span>Discover the BEST WAY TO PAY your Bills in ONE PLACE!</span>,
                          // <Button
                          //   component={Link}
                          //   to="/public/billpay/now"
                          //   color="primary"
                          //   size="large"
                          //   variant="contained"
                          //   onClick={() => {
                          //     window.scrollTo(0, 0);
                          //     dispatch(setTabPosition(1));
                          //   }}
                          //   style={{ borderRadius: 20, marginRight: 10 }}
                          // >
                          //   Pay Online Now
                          // </Button>,
                          // <b>No Registration Required!</b>,
                          // "Scroll down to learn more!",
                      ]}
                      indentation="3%"
                  />
              </Grid>
          </Grid>

        {sm && (
          <Grid item xs={6} sm={5}>
            <img src={billPay_img} alt="billpay" className={classes.img} />
          </Grid>
        )}

          <Grid item container md={12} sm={12} >
              <Grid item container md={3} justify="center" className={classes.iconContainer} >

                      <img src={EasyImg} alt="billpay" className={classes.iconImg} />

                  <Typography
                      variant="h3"
                      style={{justifyContent:"center", color:"#1CC5FF", width:"100%", textAlign:"center"}}
                  >
                      <b>EASY</b>
                  </Typography>
                  <Typography
                      component={"span"}
                      variant={xsIconCol ? "body2" : smIconCol ? "body1" : mdIconCol ? "body1" : "h5"}
                      style={{color: theme.palette.secondary.main,}}
                      className={classes.iconContainerParagraph}
                  >
                      Pay from the comfort of your home, at work or anywhere in the world. Designed for your convenience!
                  </Typography>
              </Grid>
              <Grid item container md={3} justify="center"  className={classes.iconContainer} >

                  <img src={FASTImg} alt="billpay" className={classes.iconImg} />

                  <Typography
                      variant="h3"
                      style={{justifyContent:"center", color:"#1CC5FF", width:"100%", textAlign:"center"}}
                  >
                      <b>FAST</b>
                  </Typography>
                  <Typography

                      component={"span"}
                      variant={xsIconCol ? "body2" : smIconCol ? "body1" : mdIconCol ? "body1" : "h5"}
                      style={{color: theme.palette.secondary.main,}}
                      className={classes.iconContainerParagraph}
                  >
                      Fast Processing. Pay your bill in less than 2 minutes. Payments are reflected in your utility/vendor accounts in near real-time (24 hours or less).


                  </Typography>
              </Grid>
              <Grid item container md={3} justify="center" className={classes.iconContainer} >

                  <img src={SafeImg} alt="billpay" className={classes.iconImg} />

                  <Typography
                      variant="h3"
                      style={{justifyContent:"center", color:"#1CC5FF", width:"100%", textAlign:"center"}}
                  >
                      <b>SAFE</b>
                  </Typography>
                  <Typography
                      component={"span"}
                      variant={xsIconCol ? "body2" : smIconCol ? "body1" : mdIconCol ? "body1" : "h5"}
                      style={{color: theme.palette.secondary.main,}}
                      className={classes.iconContainerParagraph}
                  >
                      Our robust payment platform is built on a system of overlapping security defenses that protect you and give you peace of mind every time you pay.


                  </Typography>
              </Grid>
              <Grid item container md={3} justify="center"  className={classes.iconContainer}>

                  <img src={FreeImg} alt="billpay" className={classes.iconImg} />

                  <Typography
                      variant="h3"
                      style={{justifyContent:"center", color:"#1CC5FF", width:"100%", textAlign:"center"}}
                  >
                  <b>FREE</b>
                  </Typography>
                  <Typography
                      component={"span"}
                      variant={xsIconCol ? "body2" : smIconCol ? "body1" : mdIconCol ? "body1" : "h5"}
                      style={{color: theme.palette.secondary.main,}}
                      className={classes.iconContainerParagraph}
                  >
                      Zero fees on Utility bill payments made Online.

                  </Typography>
              </Grid>
          </Grid>
          <Grid item container xs={12} sm={12}>

              <Grid item container>
                  <TextList
                      items={[
                          <span><strong>YOOZ It</strong> anywhere, anytime you want! Choose the Payment Method that's right for you! </span>,

                      ]}
                      indentation="3%"
                  />
              </Grid>
          </Grid>
      </Grid>
    </Container>
  );
}
